(function() {

	var Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Container = include("PIXI.Container"),
		AdvancedMovieClip = include("springroll.pixi.AdvancedMovieClip"),
		Tween = include("createjs.Tween"),
		GeomUtils = include("heist.GeomUtils"),
		Polygon = include("heist.Polygon"),
		Sound = include("springroll.Sound");

	var Guard = function(state)
	{
		this.state = state;
		
		var app = this.app = Application.instance;
		Sound.instance.preload("SFX_ChickenTap");
		Sound.instance.preload("SFX_ElmoCaught");
		var config = app.config.game.stealth.guardData;
		this.turnData = config.turn;
		this.viewPositions = config.viewPositions;
		this.beakPositions = config.beakPositions;
		this.animScale = config.scale;
		this.animSpeed = config.animSpeed;
		this.defaultSpeed = config.defaultSpeed;

		this.viewCollision = new Polygon(config.viewCollision);
		this.bodyCollision = new Polygon(config.bodyCollision);
		
		Container.call(this);
		
		var guardData = app.getCache("GuardData");
		this.origin = guardData.origin;
		var atlas = app.getCache("GuardAtlas");
		this._anim = new AdvancedMovieClip(guardData, atlas);
		this.addChild(this._anim);
		this._anim.scale.x = this._anim.scale.y = this.animScale;
		
		this._beakAnim = new AdvancedMovieClip(app.getCache("BeakData"), atlas);
		this.addChild(this._beakAnim);
		this._beakAnim.scale.x = this._anim.scale.y = this.animScale;

		this._light = new Sprite(Texture.fromFrame("Light"));
		this._light.anchor.y = 0.5;
		this.addChild(this._light);

		this.path = null;
		this.pathIndex = -1;
		this.enabled = false;

		this.facing = null;
		this.turnOrder = null;
		this.turnTimes = null;
		this.currentAnim = null;
		this.currentBeakAnim = null;
		
		this.walkAnimInstance = null;
		this.walkTween = null;

		this._waitTimer = 0;

		this.update = this.update.bind(this);
		this._nextNode = this._nextNode.bind(this);
		//this._turn = this._turn.bind(this);
		
		this._anim.interactive = true;
		this.onClick = this.onClick.bind(this);
		this._anim.on("click", this.onClick);
		this._anim.on("tap", this.onClick);
		
		this.onBawkDone = this.onBawkDone.bind(this);
		this.onCatchDone = this.onCatchDone.bind(this);
		
		this.type = "guard";
	};

	// Extend MovieClip
	var s = Container.prototype;
	var p = Guard.prototype = Object.create(s);
	
	Object.defineProperty(p, "worldPos", {
		get: function() { return this.position.y; }
	});
	
	//initialize guard with path data
	p.setPath = function(path, maskData)
	{
		if(this._light.mask)
		{
			this.removeChild(this._light.mask);
			this._light.mask = null;
		}
		//draw the mask for the flashlight so it doesn't display through walls
		var mask;
		if(maskData)
		{
			mask = new PIXI.Graphics();
			mask.moveTo(maskData[0].x, maskData[0].y);
			mask.beginFill(0, 1);
			for(var i = 1; i < maskData.length; ++i)
			{
				var data = maskData[i];
				if(data.cpX !== undefined)
				{
					mask.quadraticCurveTo(data.cpX, data.cpY, data.x, data.y);
				}
				else
				{
					mask.lineTo(data.x, data.y);
				}
			}
			mask.lineTo(maskData[0].x, maskData[0].y);
			mask.endFill();
			this.addChild(mask);
			this._light.mask = mask;
		}
		
		this.pathIndex = -1;
		this.path = path.slice();
		//remove the first node, as it is the initial positioning
		var node = this.path.shift();

		//set initial positioning
		this.facing = node.face;
		var animName = "idle" + this.facing;
		this._playAnim(animName);
		this.app.animator.stop(this._anim);
		this.app.animator.stop(this._beakAnim);
		this.position.x = node.x;
		this.position.y = node.y;
		
		if(mask)
		{
			mask.position.x = -this.position.x;
			mask.position.y = -this.position.y;
		}

		this.app.on("update", this.update, -1);
	};
	
	p.playCatch = function()
	{
		this.currentBeakAnim = "caught";
		this.app.animator.play(this._beakAnim, {anim: "caught" + this.facing, audio: "SFX_ElmoCaught"}, this.onCatchDone);
	};
	
	p.onClick = function()
	{
		if(!this.enabled || this.currentBeakAnim) return;
		
		this.currentBeakAnim = "bawk";
		this.app.animator.play(this._beakAnim, {anim: "bawk" + this.facing, audio: "SFX_ChickenTap"}, this.onBawkDone);
		this.state.guardClicks++;
	};
	
	p.onCatchDone = function()
	{
		this.currentBeakAnim = null;
		this._beakAnim.gotoAndStop("bawk" + this.facing);
		
		this.state.catchElmoVO();
	};
	
	p.onBawkDone = function()
	{
		this.currentBeakAnim = null;
		this._beakAnim.gotoAndStop("bawk" + this.facing);
	};

	p.update = function(elapsed)
	{
		if(!this.enabled) return;
		
		//if waiting in place
		if(this._waitTimer > 0)
		{
			this._waitTimer -= elapsed;
			if(this._waitTimer <= 0)
				this._nextNode();
			return;
		}
		
		//update beak & light for current animation
		if(this.currentAnim)
		{
			var lightData = this.viewPositions[this.currentAnim];
			if(lightData && lightData[this._anim.currentFrame])
			{
				this.setLightPos(lightData[this._anim.currentFrame]);
			}
			this.updateBeakPos();
		}
		
		//update mask for current position
		var position = this.position;
		var mask = this._light.mask;
		if(mask)
		{
			mask.position.x = -position.x;
			mask.position.y = -position.y;
		}
		
		//update collision polygons
		var lightPosition = this._light.position;
		this.viewCollision.setOrigin(position.x + lightPosition.x, position.y + lightPosition.y);
		this.bodyCollision.setOrigin(position.x, position.y);
	};

	p._nextNode = function()
	{
		this.walkTween = null;
		this.pathIndex++;
		if(this.pathIndex >= this.path.length)
			this.pathIndex = 0;
		var node = this.path[this.pathIndex];
		//wait in place
		if(typeof node == "number")
		{
			this._waitTimer = node;
			this._playAnim("idle" + this.facing);
		}
		else
		{
			//either trigger a hint or wait extra if a hint is active
			if(node.hasOwnProperty("hint"))
			{
				if(node.time)
				{
					if(this.state.isHintActive(node.hint))
					{
						this._waitTimer = node.time;
						this._playAnim("idle" + this.facing);
					}
					else
						this._nextNode();
				}
				else
				{
					//trigger hint
					this.state.triggerMoveHint(node.hint);
					//continue to next node
					this._nextNode();
				}
			}
			//move position
			else if(node.x)
			{
				//get the time and convert it to milliseconds
				var speed = node.speed || this.defaultSpeed;
				var time = GeomUtils.distance(this.position, node) / speed * 1000;
				this.walkTween = Tween.get(this.position)
									.to({x: node.x, y: node.y}, time)
									.call(this._nextNode);
				var animName = "walk" + this.facing;
				this._playAnim({anim:animName, speed:speed / this.animSpeed});
			}
			//change direction
			else if(node.face)
			{
				this.facing = node.face;
				this._nextNode();
			}
			else
			{
				//improper node - skip
				this._nextNode();
			}
		}
	};
	
	//plays an animation, including accounting for changes for the flashlight and beak
	p._playAnim = function(animData, callback)
	{
		var animName = typeof animData == "string" ? animData : animData.anim;
		this.currentAnim = animName;
		if(this.app.animator.hasAnimation(this._anim, animName))
			this.walkAnimInstance = this.app.animator.play(this._anim, animData, callback);
		else
		{
			this.app.animator.stop(this._anim);
			this.walkAnimInstance = null;
			this._anim.gotoAndStop(animName);
		}
		var lightData = this.viewPositions[animName];
		if(lightData)
		{
			if(Array.isArray(lightData))
				lightData = lightData[0];
			//update light art
			this.setLightPos(lightData);
		}
		animName = (this.currentBeakAnim ? this.currentBeakAnim : "bawk") + this.facing;
		//get the timeline for safety - sometimes in a Map it can have an entry of undefined,
		//where it should have been deleted from the Map instead?
		var timeline = this.app.animator.getTimeline(this._beakAnim);
		if(!this.currentBeakAnim || !timeline)
		{
			this.app.animator.stop(this._beakAnim);
			this._beakAnim.gotoAndStop(animName);
		}
		else
		{
			//do some shenanigans to change the animation without interfering with
			//the playing audio for the animation
			var instance = timeline.instance;
			var labels = this.app.getCache("BeakData").labels;
			instance.firstFrame = labels[animName];
			instance.lastFrame = labels[animName + "_stop"];
			instance.startTime = instance.firstFrame / this._beakAnim.framerate;
			instance.setPosition(instance.position);
		}
		this.updateBeakPos();
	};
	
	p.updateBeakPos = function()
	{
		var position;
		var data = this.beakPositions[this.currentAnim];
		if(data)
		{
			if(!Array.isArray(data))
				position = data;
			else
			{
				var index = this._anim.currentFrame;
				for(; !position; --index)
				{
					position = data[index];
				}
			}
			this._beakAnim.position.x = position.x;
			this._beakAnim.position.y = position.y;
		}
	};
	
	p.setLightPos = function(lightData)
	{
		var _light = this._light;
		if(lightData.above)
			this.addChild(_light);
		else
			this.addChildAt(_light, 0);
		_light.rotation = lightData.rotation * Math.DEG_TO_RADS;
		_light.position.x = (lightData.x - this.origin.x) * this.animScale;
		_light.position.y = (lightData.y - this.origin.y) * this.animScale;
		//update view polygon
		this.viewCollision.rotation = lightData.rotation;
		this.viewCollision.setOrigin(this.position.x + _light.position.x,
			this.position.y + _light.position.y);
	};
	
	p.pause = function()
	{
		this.enabled = false;
		if(this.walkTween)
		{
			this.walkTween.setPaused(true);
		}
		if(this.walkAnimInstance)
		{
			this.walkAnimInstance.paused = true;
		}
	};
	
	p.resume = function()
	{
		this.enabled = true;
		if(this.walkTween)
		{
			this.walkTween.setPaused(false);
		}
		if(this.walkAnimInstance)
		{
			this.walkAnimInstance.paused = false;
		}
	};

	p.stop = function()
	{
		this.enabled = false;
		this.walkTween = null;
		this.walkAnimInstance = null;
		this.app.animator.stop(this._anim);
		this.app.animator.stop(this._beakAnim);
		Tween.removeTweens(this.position);
		this.app.off("update", this.update);
		this._waitTimer = 0;
		this.currentAnim = null;
		this.currentBeakAnim = null;
	};
	
	p.cleanup = function()
	{
		if(this._light.mask)
		{
			this.removeChild(this._light.mask);
			this._light.mask = null;
		}
	};

	p.destroy = function()
	{
		this.stop();
		this.path = null;
		this.removeChildren();
		if(this._light.mask)
		{
			this._light.mask.destroy();
			this._light.mask = null;
		}
		this._beakAnim.destroy();
		this._anim.destroy();
		this._light.destroy();
		this._anim = this._beakAnim = this._light = null;
		this.state = this.turnData = this.viewPositions = null;
		this.viewCollision.destroy();
		this.bodyCollision.destroy();
		this.viewCollision = this.bodyCollision = null;
		this.update = this._nextNode = this._turn = null;
	};

	namespace('heist').Guard = Guard;
}());